"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAppointmentGapList = exports.THROW_APPOINTMENT_ERROR = exports.SET_APPOINTMENT_LOADING = exports.LOAD_APPOINTMENT_GAPS = void 0;
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _myAppointmentApi = require("../../../csc/api/myAppointmentApi");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var SET_APPOINTMENT_LOADING = exports.SET_APPOINTMENT_LOADING = 'api/reducer/APPOINTMENT_LOADING';
var THROW_APPOINTMENT_ERROR = exports.THROW_APPOINTMENT_ERROR = 'api/reducer/APPOINTMENT_ERROR';
var LOAD_APPOINTMENT_GAPS = exports.LOAD_APPOINTMENT_GAPS = 'api/reducer/LOAD_APPOINTMENT_GAPS';
var myAppointmentLoadGapsAction = {
  data: (0, _propTypes.shape)({
    innerData: _propTypes.default.array.isRequired,
    week: _propTypes.default.object.isRequired
  }).isRequired,
  type: _propTypes.default.string.isRequired
};
var loadAppointmentGapList = exports.loadAppointmentGapList = function loadAppointmentGapList(dispatch, contractAccountId, assOrderId, weeks) {
  if (contractAccountId && assOrderId && weeks.length > 0) {
    dispatch({
      type: SET_APPOINTMENT_LOADING
    });
    (0, _myAppointmentApi.getAppointmentGapList)(contractAccountId, assOrderId, weeks[0].from, weeks[0].to).then(function (responseGapList) {
      var _responseGapList$data, _responseGapList$data2;
      if (((_responseGapList$data = responseGapList.data) === null || _responseGapList$data === void 0 ? void 0 : (_responseGapList$data2 = _responseGapList$data.gaps) === null || _responseGapList$data2 === void 0 ? void 0 : _responseGapList$data2.length) === 0 && weeks.length > 1) {
        loadAppointmentGapList(dispatch, contractAccountId, assOrderId, weeks.slice(1));
      }
      dispatch({
        type: LOAD_APPOINTMENT_GAPS,
        data: {
          innerData: responseGapList.data.gaps,
          week: weeks[0]
        }
      });
    }).catch(function (errorResponse) {
      var _errorResponse$respon;
      if ((errorResponse === null || errorResponse === void 0 ? void 0 : (_errorResponse$respon = errorResponse.response) === null || _errorResponse$respon === void 0 ? void 0 : _errorResponse$respon.status) === 404) {
        if ((weeks === null || weeks === void 0 ? void 0 : weeks.length) > 1) {
          loadAppointmentGapList(dispatch, contractAccountId, assOrderId, weeks.slice(1));
        } else {
          dispatch({
            type: LOAD_APPOINTMENT_GAPS,
            data: {
              innerData: [],
              week: weeks.length === 1 ? weeks[0] : null
            }
          });
        }
      } else {
        dispatch({
          type: LOAD_APPOINTMENT_GAPS,
          data: {
            innerData: null
          }
        });
      }
    });
  }
};